import MergeHelp from '../../../../../assets/images/ringcentral-help-merge.png'

export const RingCentralHowItWorks = () => {
  return (
    <div>
      <div>
        <h5>1. Connect your RingCentral account.</h5>
        <div className='mt-2'>Zocks redirects you to Ring Central where you can authorize the access request to set up the connection.</div>
      </div>
      <div className='mt-3'>
        <h5>2. Zocks matches calls to meetings automatically</h5>
        <ul className='mt-2'>
          <li>For scheduled upcoming meetings, set the meeting platform to "RingCentral".</li>
          <li>Zocks links calls to scheduled meetings by phone number, or creates new meetings for unexpected calls.</li>
        </ul>
      </div>

      <div>
        <h5>3. Merge Zocks into your calls</h5>
        <div className='mt-2'>
          When you start a call, Zocks calls you separately. Use RingCentral's merge feature to combine both calls to add your AI Assistant to the conversation.
          You can manually add or remove the assistant during any live call.
        </div>
        <div className='mt-4 d-flex justify-content-center'>
          <img className='w-100 mw-800' alt='How to merge Zocks into your calls' src={MergeHelp} />
        </div>
      </div>
    </div>
  )
}
